import { useTranslate } from 'react-polyglot';
import { observer } from 'mobx-react';

import {
  BasicTitle,
  BiggerSubtitle,
  BigSubtitle,
  SmallTitle,
  useBreakpoint,
} from '@genially/design-system';

import { RouteNames } from '../../../../../../../../bootstrap/domain/RouteNames';
import { CopyLinkButton } from '../../../../../../../../shared/application/components/CopyLinkButton/CopyLinkButton';
import { QRCode } from '../../../../../../../../shared/application/components/QRCode/QRCode';
import { useNavigation } from '../../../../../../../../shared/application/hooks/useNavigation';
import { useNotificationManager } from '../../../../../../../../shared/application/services/useNotificationManager';
import { isIframeOfAddonMeet } from '../../../../../../../../shared/application/utils/isIframeOf';
import { shareSessionCode } from '../../../../../../../../shared/application/utils/shareSessionCode';
import { splitSessionCodeByDash } from '../../../../../../../../shared/application/utils/splitSessionCodeByDash';
import { useHostClientContext } from '../../../HostClientProvider/hooks/useHostClientContext';
import { HostGameBreakdownSteps } from '../../../HostGame/HostGame.constants';
import { HostLobbyBreakdownSteps } from '../../HostLobby.constants';
import {
  ButtonWrapper,
  Content,
  QRCodeWrapper,
  SessionIdWrapper,
  StyledCopyIcon,
  StyledResponsiveSessionId,
  StyledResponsiveSubtitle,
  StyledResponsiveTitle,
  Wrapper,
} from './ConnectionInfo.styled';

export const ConnectionInfo = observer(() => {
  const t = useTranslate();
  const { getFullUrl } = useNavigation();
  const { isDownwards } = useBreakpoint();

  const { notificationManager } = useNotificationManager();

  const { client } = useHostClientContext();

  const isMobile = isDownwards(HostGameBreakdownSteps.forth);

  const { geniallyId, sessionId } = client;

  const sessionIdSplitByDash = splitSessionCodeByDash(client.sessionId);

  const qrUrl = `${getFullUrl({
    to: RouteNames.PlayerUsernameSelection,
    params: {
      geniallyId,
      sessionId,
    },
  })}?from=lobby`;

  const handleCopyClick = async () => {
    shareSessionCode({
      geniallyId,
      sessionId,
      isMobile,
      notificationManager,
      t,
      from: 'lobby',
    });
  };

  return (
    <Wrapper>
      <QRCodeWrapper>
        <QRCode url={qrUrl} sessionId={sessionIdSplitByDash} geniallyId={geniallyId} />
      </QRCodeWrapper>

      <Content>
        {!isMobile && !isIframeOfAddonMeet() && (
          <StyledResponsiveTitle
            with={BigSubtitle}
            on={{
              [HostLobbyBreakdownSteps.first]: SmallTitle,
            }}
          >
            {t('__new.play.creatorLobby.copyLink.subtitle')}
          </StyledResponsiveTitle>
        )}

        <StyledResponsiveSubtitle
          with={BiggerSubtitle}
          on={{
            [HostLobbyBreakdownSteps.first]: BigSubtitle,
          }}
        >
          {t('__new.play.creatorLobby.join.title')}
        </StyledResponsiveSubtitle>

        <SessionIdWrapper onClick={isMobile ? handleCopyClick : undefined}>
          <StyledResponsiveSessionId
            with={BasicTitle}
            on={{
              [HostLobbyBreakdownSteps.first]: BasicTitle,
            }}
          >
            {sessionIdSplitByDash}
          </StyledResponsiveSessionId>

          {isMobile && <StyledCopyIcon />}
        </SessionIdWrapper>

        {!isMobile && !isIframeOfAddonMeet() && (
          <ButtonWrapper>
            <CopyLinkButton />
          </ButtonWrapper>
        )}
      </Content>
    </Wrapper>
  );
});
